module.exports = window["dokan"]["utilities"];